import { Group } from '@mantine/core'
import { useTrueToFalse } from 'hooks/utils'
import { useEffect, useState } from 'react'
import ShibaButton, { ShibaButtonProps } from './ShibaButton'

export type FormButtonsProps = {
  onCancel: () => void
  submitText: string
  loading: boolean
} & ShibaButtonProps

export default function FormButtons({ onCancel, submitText, loading, disabledReason }: FormButtonsProps) {
  const isSubmitted = useTrueToFalse(loading)

  const [isSubmitBlocked, setIsSubmitBlocked] = useState(false)

  // Reset submit block after 1 second
  useEffect(() => {
    if (isSubmitted) {
      setIsSubmitBlocked(true)
      let timeout = setTimeout(() => {
        setIsSubmitBlocked(false)
      }, 1000)
      return () => clearTimeout(timeout)
    }
  }, [isSubmitted])

  return (
    <Group mt="md" justify="flex-end">
      <ShibaButton
        variant="default"
        onClick={onCancel}
        disabledReason={loading || isSubmitBlocked ? 'Trwa wysyłanie formularza' : undefined}
      >
        Anuluj
      </ShibaButton>
      <ShibaButton type="submit" variant="filled" loading={loading || isSubmitBlocked} disabledReason={disabledReason}>
        {submitText}
      </ShibaButton>
    </Group>
  )
}
